import * as React from 'react';
import { CircularProgress, circularProgressClasses, Grid } from '@mui/material';
import { Icon, Text } from '.';
import AppService from '../services/app.service';

interface Props {
  id?: string;
  caption?: string;
  value: number;
  totalValue: number;
  color?: any;
  bgColor?: any;
  icon?: string;
  iconColor?: any;
  floating?: {left?: any, top?: any}
  hideOnComplete?: boolean;
}

export const ProgressBar: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();
  const bgColor = props.bgColor || 'background.default';
  const color = props.color || 'primary.main';
  const gradientColor = 'radial-gradient(white 10%, ' +props.iconColor+ ' 200%)'
  const progressValue = Math.min(Math.floor((props.value/props.totalValue) *  100) || 0, 100);
  const value = progressValue < 100? (props.caption? props.value : progressValue).toString() : '';
  const isComplete = progressValue === 100;
  
  return (
    <>
    {props.hideOnComplete && isComplete? '' : props.totalValue > 0 &&
    <Grid container position={props.floating? 'fixed' : 'unset'} alignItems='center' justifyContent='center' bgcolor={bgColor} sx={{background: isComplete? gradientColor : '', borderRadius: '50%', height:  70, width:70}} left={props.floating?.left} top={props.floating?.top} m={1}>
      
      <CircularProgress variant='determinate' size={70} value={100} thickness={isComplete? 0.3 : 3} sx={{color: isComplete? props.iconColor : color, position: 'absolute', opacity: 0.3}}/>
      <CircularProgress variant='determinate' size={70} value={progressValue} thickness={isComplete? 0 : 4} sx={{ color: color, position: 'absolute', [`& .${circularProgressClasses.circle}`]: {strokeLinecap: 'round'}}}/>     
      <Grid position= 'absolute' display='flex' alignItems='center' ml={isComplete? 0 : 0.5}> 
        <Text label={value} color={color} size={isMobile? 'extralarge' : 'extralarge'} icon={!props.caption && isComplete? (props.icon || 'verified') : ''} iconSize='superlarge' iconColor={props.iconColor || 'primary.dark'}/>
        {!props.caption && progressValue < 100 && <Icon name='percent' size={isMobile? 'extrasmall' : 'small'} color={color} /> }
      </Grid>
      <Text label={props.caption} color={color} size='small' textAlign='center' marginTop={5}/>
    </Grid>
    }
    </>
  )
}


